import templatedUrl from 'url-template';

export default function(userPicture, size) {
  const userPictureTemplateHref = userPicture.templateHref;
  return templatedUrl.parse(userPictureTemplateHref).expand({ height: size, width: size });
}


// WEBPACK FOOTER //
// ./src/lib/userPictureUrlForSize.js